import AttachmentsContainer from './AttachmentsContainer';

export default AttachmentsContainer;
